export default {
    model: {
        prop: 'value',
        event: 'change',
    },

    props: {
        value: {
            type: [String, Number],
            default: '',
        },

        error: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        model: {
            /**
             * Get the model value.
             *
             * @returns {string|number} Model value.
             */
            get() {
                return this.value;
            },

            /**
             * Set the model value.
             *
             * @param {string|number} value Model value.
             */
            set(value) {
                this.$emit('change', value);
            },
        },

        /**
         * Compute field class.
         *
         * @returns {object} Field class.
         */
        fieldClass() {
            return {
                error: this.error,
            };
        },
    },
};
